import { Config } from "@spartacus/core";

export const defaultOccUserProfileConfig: Config = {
  backend: {
    occ: {
      endpoints: {
        userRegister: 'users',
        userForgotPassword: 'forgottenpasswordtokens',
        userResetPassword: 'resetpassword',
        userUpdateLoginId: 'users/${userId}/login',
        userUpdatePassword: 'current-user/password',
        titles: 'titles',
      },
    },
  },
};
